// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__24q22","select":"Header_select__1LZwX","clinic":"Header_clinic__3Dkkr"};